import { useLocation, useParams } from 'react-router-dom';

const BUTTON_PRIORITIES = {
  // Higher numbers indicate higher priority when multiple buttons could be shown
  BACK_TO_DESIGN: 2,
  BACK_TO_LIST: 1,
} as const;

export interface NavigationConfig {
  button: {
    priority: (typeof BUTTON_PRIORITIES)[keyof typeof BUTTON_PRIORITIES];
    key: string;
    to: string;
    label: string;
  };
  navigation: {
    showNavItems: boolean;
  };
  condition: boolean;
}

export const useNavigation = () => {
  const location = useLocation();
  const { projectId, workflowId } = useParams<{ projectId: string; workflowId: string }>();
  const isWorkflowExecutionView = location.pathname.includes('/workflow-executions/workflow/');

  const navigationConfig: NavigationConfig[] = [
    {
      button: {
        priority: BUTTON_PRIORITIES.BACK_TO_DESIGN,
        key: 'back-to-design',
        to: `/projects/${projectId}/canvas/${workflowId}`,
        label: 'Back to Design',
      },
      navigation: {
        showNavItems: false,
      },
      condition: isWorkflowExecutionView && !!workflowId,
    },
    {
      button: {
        priority: BUTTON_PRIORITIES.BACK_TO_LIST,
        key: 'back-to-list',
        to: '/projects',
        label: 'Back to Projects',
      },
      navigation: {
        showNavItems: true,
      },
      condition: !!projectId,
    },
  ];

  const activeConfig = navigationConfig
    .filter((config) => config.condition)
    .sort((a, b) => b.button.priority - a.button.priority)[0];

  return {
    buttonConfig: activeConfig?.button,
    shouldShowNavItems: activeConfig?.navigation.showNavItems ?? true,
  };
};
